import { ProfileType } from '@watcherr/resources';
import * as React from 'react';
import { State } from '~/store/types';
import { t } from '~/i18n';
import ProfileFormContainer from '../Profile/ProfileForm';
import { Permission } from '@watcherr/resources';

interface ResidentFormContainerProps {
  profile: State['residentDetail']['profile'];
}

const ResidentFormContainer: React.FC<ResidentFormContainerProps> = ({ profile }) => {
  const [creationPermission, setCreationPermission] = React.useState<boolean>(false);
  React.useEffect(() => {
    Permission.getOwnPermissions().then((perm) => {
      if (perm.length != 0) {
        perm[0].entries.find((perm) => {
          if (perm.permission.name.includes('can_create_profiles')) {
            if (perm.isEnabled) {
              setCreationPermission(true);
            }
          }
        });
      }
    });
  }, []);

  return creationPermission ? (
    <ProfileFormContainer
      profileType={ProfileType.Resident}
      profile={profile ?? undefined}
      fields={['healthLevel', 'nationalNumber', 'livingUnit', 'phoneNumbers', 'birthday']}
      urlPath="residents"
      storeType="residents"
      donePath={'/residents'}
    />
  ) : (
    <p>{t('user-configuration.no-permissions')}</p>
  );
};

export default ResidentFormContainer;
